<template>
  <AdminLayout>
    <template #content>
      <div class="d-flex justify-content-between align-items-start gap-3 mb-3">
        <div>
          <h1 class="h4 mb-1">Nouveau retour fournisseur</h1>
          <small class="text-muted">Sélectionnez une commande validée et les produits à retourner.</small>
        </div>

        <button
          type="button"
          class="btn btn-outline-secondary btn-sm btn-icon-label"
          title="Retour à la liste"
          @click="$router.push({ name: 'SupplierReturns' })"
        >
          <i class="fa fa-arrow-left"></i>
          <span class="btn-label ms-1">Retour à la liste</span>
        </button>
      </div>

      <div v-if="errorMessage" class="alert alert-danger py-2">
        {{ errorMessage }}
      </div>

      <div class="card border-0 shadow-sm">
        <div class="card-body">
          <SupplierReturnForm
            mode="create"
            :initial-purchase-id="initialPurchaseId"
            :submitting="isSubmitting"
            @save="createSupplierReturn"
            @cancel="$router.push({ name: 'SupplierReturns' })"
          />
        </div>
      </div>
    </template>
  </AdminLayout>
</template>

<script>
import SupplierReturnForm from './SupplierReturnForm.vue';

export default {
  name: 'SupplierReturnCreateView',
  components: {
    SupplierReturnForm,
  },
  data() {
    return {
      isSubmitting: false,
      errorMessage: '',
    };
  },
  computed: {
    initialPurchaseId() {
      const purchaseId = Number(this.$route.query.purchase_id || 0);
      return Number.isFinite(purchaseId) && purchaseId > 0 ? purchaseId : null;
    },
  },
  methods: {
    async createSupplierReturn(payload) {
      this.isSubmitting = true;
      this.errorMessage = '';

      try {
        const response = await this.$api.post('/supplier-returns', payload);
        const supplierReturn = response.data.data;
        this.$router.push({ name: 'SupplierReturnShow', params: { id: supplierReturn.id } });
      } catch (error) {
        this.errorMessage = this.extractErrorMessage(error, 'Impossible de créer le retour fournisseur.');
      } finally {
        this.isSubmitting = false;
      }
    },
    extractErrorMessage(error, fallback) {
      if (error?.response?.data?.errors) {
        return Object.values(error.response.data.errors).flat().join(' ');
      }

      return fallback;
    },
  },
};
</script>
